import React, { ReactNode, PropsWithChildren } from "react";

import { ModalTitle } from "src/app/components/Modal/Modal";

interface ExtensionViewProps {
  title: ReactNode;
  navigationButtons?: {
    label: ReactNode | string;
    action: () => void;
  }[];
  actionButton?: ReactNode;
}

export default function ExtensionView({
  title,
  navigationButtons,
  actionButton,
  children,
}: PropsWithChildren<ExtensionViewProps>) {
  return (
    <>
      <div className="extensions__header">
        <div style={{ flex: 1 }}>
          <div className="extensions__header-navigation-buttons">
            {navigationButtons?.map((item, idx) => {
              const { label, action } = item;

              return (
                <>
                  <button
                    onClick={action}
                    className="extensions__back-btn"
                    aria-label=""
                    type="button"
                  >
                    {label}
                  </button>

                  {idx !== navigationButtons.length - 1 && <>/</>}
                </>
              );
            })}
          </div>
          <ModalTitle>{title}</ModalTitle>
        </div>
        {actionButton}
      </div>
      {children}
    </>
  );
}
